import { render, staticRenderFns } from "./OrderStateCreate.vue?vue&type=template&id=6aae2688&scoped=true"
import script from "./OrderStateCreate.vue?vue&type=script&lang=js"
export * from "./OrderStateCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae2688",
  null
  
)

export default component.exports